import React, { Component } from "react";
import BreadCrumbs from "../../../Components/UI/BreadCrumbs";
import HeaderTabs from "../../../Components/UI/HeaderTabs";
import Wrp from "../../../hoc/Wrp/Wrp";
import { withRouter } from "react-router";
import TableRecord from "../../../Components/UI/TableRecord";
import { getDateFormat } from "../../../Utils/UserFunctions";
import { callDELETE, callGET, callPOST } from "../../../Utils/ApiUtil";
import { validateFilesWithinSizeLimit, reportFileSizeValidationError } from "../../../Utils/FileUploadValidation";
import CreateDomainCertificate from "./CreateDomainCertificate";
import * as actions from "../../../store/actions";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import CertificateDetail from "./CertificateDetail";
import Buttons from "../../../Components/UI/TableRecord/TableData/Button";
import { parameterizedURLAccessToken } from "../../../Utils/CommonFunctions";
import moment from "moment";
import ImportCertificate from "./ImportCertificate";

class CertificateList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      templateCURD: "",
      isCreateNewModelOpen: false,
      isCertificateDetailModelOpen: false,
      isImportCertificateModelOpen:false,
      CertificateList: [],
      certificate: [],
      domainKey: [],
      violations: [],
      selectedCertificateFile: "",
      certificateTextArea: "",
      keyTextArea: "",
      selectedKeyChainFile: "",
      fileName: "",
      formFieldData: {
        id: {
          value: "",
          failMessage: "",
          disable:false,
        },
        unique_name: {
          value: "",
          failMessage: "",
          disable:false,
        },
        common_name: {
          value: "",
          failMessage: "",
          disable:false,
        },
        company_name: {
          value: "",
          failMessage: "",
          disable:false,
        },
        department_name: {
          value: "",
          failMessage: "",
          disable:false,
        },
        key_size: {
          value: "2048",
          failMessage: "",
          disable:false,
        },
        state_name: {
          value: "",
          failMessage: "",
          disable:false,
        },
        email_id: {
          value: "",
          failMessage: "",
          disable:false,
        },
        city_name: {
          value: "",
          failMessage: "",
          disable:false,
        },
        country_code: {
          value: "",
          failMessage: "",
          disable:false,
        },
        is_active: {
          value: false,
          failMessage: "",
          disable:false,
        },
      },
      tableRecords: {
        tableHead: [
          {
            name: "Action",
            type: "Actions",
            href: "",
            isShow: true,
            clickHandler: "",
            attributes: {
              style: { wsidth: "75px" },
            },
          },
          {
            name: "Common Name ",
            type: "HyperLink",
            clickHandler: "",
            isShow: true,
            attributes: {},
          },
          {
            name: "Certificate Type",
            type: "Text",
            clickHandler: "",
            isShow: true,
            attributes: {},
          },
          {
            name: "Is Active ",
            type: "Status",
            clickHandler: "",
            isShow: true,
            attributes: {},
          },
          {
            name: "Created at",
            type: "RawData",
            clickHandler: "",
            isShow: true,
            attributes: {},
          },
          {
            name: "Certificate Expiry Date ",
            type: "Text",
            clickHandler: "",
            isShow: true,
            attributes: {},
          },
        ],
        tableData: [],
        pagination: {
          page: 0,
          orderBy: "",
          perPage: 10,
          direction: "ASC",
          totalRecords: 0,
          search: "",
        },
      },
    };
  }

  componentDidMount = () => {
    this.getCertificateList();
  };
  componentDidUpdate = () => {};

  toggleModel = (model) => {
    console.log('toggleModel',model);
    if (model !== undefined && model !== "") {
      this.setState({
        isCreateNewModelOpen:
          model === "create" ? !this.state.isCreateNewModelOpen : false,
        isCertificateDetailModelOpen:
          model === "detail" ? !this.state.isCertificateDetailModelOpen : false,
        isImportCertificateModelOpen:
          model === "import" ? !this.state.isImportCertificateModelOpen : false,
      });
    }
  };
  CreateNewCertificateModel = () => {
    let updateState = this.clearFormFields(this.state.formFieldData);

    this.setState({
      formFieldData: updateState,
    });
    this.toggleModel("create");
  };

  clearFormFields = (updateState) => {
    console.log("clearFormFields", updateState);
    updateState.id = { value: "", failMessage: "",disabled:false };
    updateState.unique_name = { value: "", failMessage: "",disabled:false};
    updateState.common_name = { value: "", failMessage: "",disabled:false };
    updateState.company_name = { value: "", failMessage: "",disabled:false };
    updateState.department_name = { value: "", failMessage: "",disabled:false };
    updateState.key_size = { value: "2048", failMessage: "",disabled:false };
    updateState.state_name = { value: "", failMessage: "",disabled:false };
    updateState.email_id = { value: "", failMessage: "" ,disabled:false};
    updateState.city_name = { value: "", failMessage: "" ,disabled:false};
    updateState.country_code = { value: "", failMessage: "",disabled:false };
    updateState.is_active = { value: false, failMessage: "",disabled:false };
    return updateState;
  };

  editHandler = (item) => {
    console.log("editHandler", item);
    let updateState = this.state.formFieldData;
    updateState.id = { value: item.id, failMessage: "", disable:item.is_active };

    updateState.unique_name = { value: item.unique_name, failMessage: "",disabled:item.is_active };
    updateState.common_name = { value: item.common_name, failMessage: "",disabled:item.is_active };
    updateState.company_name = { value: item.company_name, failMessage: "" ,disabled:item.is_active};
    updateState.department_name = {
      value: item.department_name,
      failMessage: "",
      disabled:item.is_active
    };
    updateState.key_size = { value: item.key_size, failMessage: "",disabled:item.is_active };
    updateState.state_name = { value: item.state_name, failMessage: "",disabled:item.is_active };
    updateState.email_id = { value: item.email_id, failMessage: "",disabled:item.is_active };
    updateState.city_name = { value: item.city_name, failMessage: "",disabled:item.is_active };
    updateState.country_code = { value: item.country_code, failMessage: "",disabled:item.is_active };
    updateState.is_active = { value: item.is_active, failMessage: "",disabled:item.is_active };
    this.setState({
      formFieldData: updateState,
    });
    this.toggleModel("create");
  };

  valueChangeHandler = (e) => {
    console.log("valuehandler", e);
    let name = e.target.name;
    let value = e.target.value;
    if (name === "certificateTextArea") {
      this.setState({
        certificateTextArea: value,
      });
      return;
    }
    if (name === "keyChainTextArea") {
      this.setState({
        keyTextArea: value,
      });
      return;
    }
    console.log("name", name, "value", value);
    const formFieldData = this.state.formFieldData;
    let update = { ...formFieldData[name], value: value, failMessage: "" };

    this.setState({
      formFieldData: { ...formFieldData, [name]: { ...update } },
    });
  };

  PickListChangeHandler = (value) => {
    console.log("PickListCHangeHandler", value);
    const formFieldData = this.state.formFieldData;
    let update = {
      ...formFieldData["country_code"],
      value: value,
      failMessage: "",
    };
    this.setState({
      formFieldData: {
        ...formFieldData,
        country_code: { ...update },
      },
    });
  };

  FormValidation = () => {
    return true;
  };

  
   

  saveHandler = (validation = "false") => {
    const {
      id,
      unique_name,
      common_name,
      company_name,
      department_name,
      key_size,
      state_name,
      email_id,
      city_name,
      country_code,
    } = this.state.formFieldData;
    const body = {
      id: id.value,
      unique_name: unique_name.value,
      common_name: common_name.value,
      company_name: company_name.value,
      city_name: city_name.value,
      email_id: email_id.value,
      country_code: country_code.value,
      state_name: state_name.value,
      department_name: department_name.value,
      key_size: key_size.value,
    };
    const header = { "Content-Type": "application/json" };
    this.props.Loader();
    callPOST("domain/certificate/save", body, header).then(
      (response) => {
        console.log("response", response);
        const responseData = response.data;
        this.props.Loader();
        if (response.status === 200) {
          if (responseData.code === 200) {
            this.props.succMessage(responseData.message);
            this.getCertificateList();
            this.toggleModel("create");
          } else if (responseData.code === 400) {
            let updateFormField = this.state.formFieldData;
            responseData.violations.map((item) => {
              console.log("violations", item);
              let update = {
                ...updateFormField[item.field_name],
                failMessage: item.message,
              };
              updateFormField = {
                ...updateFormField,
                [item.field_name]: { ...update },
              };
            });
            console.log("final fieldData", updateFormField);
            this.setState({
              formFieldData: updateFormField,
            });
          }
        } else {
          this.props.failMessage(responseData.message);
        }
      },
      (error) => {
        console.log("error", error);
        this.props.Loader();
      }
    );
  };

  recordChangeHandler = async (paginationRequest, loader) => {
    console.log("recordChangeHandler", paginationRequest);
    let updatedTableRecords = this.state.tableRecords;
    if (paginationRequest !== undefined && paginationRequest !== null) {
      updatedTableRecords.pagination = {
        ...updatedTableRecords.pagination,
        ...paginationRequest,
      };

      this.setState({ tableRecords: updatedTableRecords });
      this.getCertificateList(updatedTableRecords.pagination);
    }
  };

  // Upload Stage : 1 on selecting certificate file or key_chain file method
  fileOnSelect = (id, e) => {
    console.log("fileOnSelect", id, e.target);
    const files = e.target.files;
    const fileType = e.target.name;
    if (fileType === "certificate") {
      this.setState({
        selectedCertificateFile: files[0],
      });
    } else if (fileType === "key_chain") {
      this.setState({
        selectedKeyChainFile: files[0],
      });
    }
  };

  uploadFiles = (file, id) => {
    console.log("uploadCertificate", file, id);
    let files = [];

    if (file === "certificate" && this.state.selectedCertificateFile !== "") {
      files.push(this.state.selectedCertificateFile);
    } else if (file === "key_chain" && this.state.selectedKeyChainFile !== "") {
      files.push(this.state.selectedKeyChainFile);
    } else if (file === "certificateTextValue") {
      const { certificateTextArea } = this.state;
      var createFile = new File(
        [certificateTextArea],
        "copied_certificate.txt",
        {
          type: "text/plain",
        }
      );
      file = "certificate";
      console.log("textBox createdFile", createFile);
      files.push(createFile);
    } else if (file === "keyChainTextValue") {
      const { keyTextArea } = this.state;
      var createKeyChainFile = new File([keyTextArea], "copied_keychain.txt", {
        type: "text/plain",
      });
      file = "key_chain";
      console.log("keychain upload file", createKeyChainFile);
      files.push(createKeyChainFile);
    }
    console.log("uploadedFile", files[0]);
    if (files.length > 0) {
      const sizeValidation = validateFilesWithinSizeLimit(files);
      if (!sizeValidation.valid) {
        reportFileSizeValidationError(sizeValidation.errorMsg, {
          failMessage: this.props.failMessage,
        });
        return;
      }
      let APIURL = "domain/certificate/" + id + "/upload";
      const header = { "Content-Type": "multipart/form-data" };
      const formData = new FormData();
      formData.append("file", files[0]);
      formData.append("type", file);
      callPOST(APIURL, formData, header)
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;
            console.log("response", response);
            if (response.code === 200) {
              const responseData = response.data;
              this.getCertificateList();
              let domainKeyId = response.data.domain_key_id;
              if (domainKeyId !== undefined && domainKeyId !== "") {
                this.getDomainKey(domainKeyId);
              }
              this.props.succMessage(response.message);
            } else {
              this.props.failMessage(
                response.message !== ""
                  ? response.message
                  : "Something went wrong.."
              );
            }
          } else {
            this.props.failMessage("Something went wrong..");
          }
        })
        .catch((err) => {
          console.log(err);
          this.props.failMessage("Something went wrong..");
        });
    } else {
      this.props.failMessage("please select file and then upload");
    }
  };

  fileDownload = (id, fileType) => {
    console.log("CSR File Download ");

    console.log("FileType", fileType);
    if (id === undefined) {
      id = this.state.item.id;
    }
    let API = "domain/certificate/" + id + "/download?file=" + fileType;
    var File = parameterizedURLAccessToken(API);
    if (File != null) {
      document.location.href = File;
      this.props.succMessage("CSR File Download Shortly");
    } else {
      this.props.failMessage("File not found");
    }
  };

  CertificateDetailToggel = (item) => {
    console.log("CertificateDetailToggel", item);
    this.getDomainKey(item.domain_key_id);
    this.setState({
      certificate: item,
      domainKey: [],
      fileName: "",
      keyTextArea: "",
      certificateTextArea: "",
    });
    this.toggleModel("detail");
  };

  getDomainKey = (id) => {
    console.log("Getting Domain Key", id);
    if(id!==undefined && id!==""){
      callGET("domain/key/" + id).then(
        (response) => {
          console.log("Domain Key Response", response);
          const responseData = response.data;
          if (response.status === 200) {
            if (responseData.code === 200) {
              this.setState({
                domainKey: responseData.data,
              });
            }
          }
        },
        (error) => {
          console.log("Error", error);
        }
      );
    }
    
  };
  deleteCertificateHandler = (id) => {
    console.log("deleting Certificate", id);
    const { Loader, succMessage, failMessage } = this.props;
    Loader();
    callDELETE("domain/certificate/" + id + "/delete").then(
      (response) => {
        const responseData = response.data;
        Loader();
        console.log("response", response);
        if (response.status === 200) {
          this.getCertificateList();
          succMessage(responseData.message);
        } else {
          failMessage(responseData.message);
        }
      },
      (error) => {
        Loader();
        console.log("error", error);
      }
    );
  };

  getSelfAuthorizedCertificate = (id) => {
    console.log("getSelfAuthorizedCertificate", id);
    const { Loader, succMessage, failMessage } = this.props;
    Loader();
    callPOST("domain/certificate/" + id + "/self-signed").then(
      (response) => {
        const responseData = response.data;
        Loader();
        console.log("response", response);
        if (response.status === 200) {
          this.getCertificateList();
          this.setState({
            isCertificateDetailModelOpen:
              !this.state.isCertificateDetailModelOpen,
          });
          succMessage(responseData.message);
        } else {
          failMessage(responseData.message);
        }
      },
      (error) => {
        console.log("error", error);
      }
    );
  };

  importCertificateHandler=()=>{
   this.setState({
    isImportCertificateModelOpen:true
   })
  }

  getCertificateList = (paginationRequest) => {
    console.log("getCertificateList START");
    const { Loader } = this.props;
    let pagination = this.state.tableRecords.pagination;
    if (paginationRequest !== null && paginationRequest !== undefined) {
      pagination = paginationRequest;
    }
    const page = pagination.page;
    const orderBy = pagination.orderBy;
    const perPage = pagination.perPage;
    const direction = pagination.direction;
    const search = pagination.search;
    const queryString =
      "?query=" +
      search +
      "&page=" +
      page +
      "&orderBy=" +
      orderBy +
      "&size=" +
      perPage +
      "&direction=" +
      direction;
    let API_URL = "domain/certificate/search";
    Loader();
    callGET(API_URL + queryString).then(
      (response) => {
        Loader();
        if (response.status === 200) {
          const responseData = response.data.data;
          console.log("responseData", responseData);

          let updateTableData = responseData.content.map((item) => {
            let CreateDate = (
              <>
                {moment(item.created_at).format(getDateFormat("Date")) + " "}
                <span className="text-danger text-small">
                  {moment(item.created_at).format("HH:mm")}
                </span>
              </>
            );
            // let expiry = moment.form;
            return {
              actions: [
                {
                  type: "edit",
                  attributes: {
                    className: "p-1",
                  },
                  name: "",
                  clickHandler: this.editHandler.bind(this, item),
                },
                {
                  type: "delete",
                  attributes: {
                    className: "p-1",
                  },
                  clickHandler: this.deleteCertificateHandler.bind(
                    this,
                    item.id
                  ),
                  name: "",
                },
              ],
              lable_name: {
                value: item.common_name !== undefined ? item.common_name : "",
                className: "text-info textUnderline cursor-pointer",
                clickHandler: this.CertificateDetailToggel.bind(this, item),
              },
              type: item.type !== undefined ? item.type : "-",
              is_active: {
                checked: item.is_active,
              },
              createdAt: CreateDate,
              expiry_date : 
                (item.expiry_date !== undefined && item.expiry_date!=="")
                  ? moment(item.expiry_date).format(getDateFormat())
                  : "-",
            };
          });

          console.log("certificate Data", updateTableData);
          const totalRecords = responseData.total_elements;
          console.log("totalRecords", totalRecords);
          this.setState({
            CertificateList: responseData.content,
            tableRecords: {
              tableData: { data: updateTableData, status: 200 },
              tableHead: this.state.tableRecords.tableHead,
              pagination: {
                ...this.state.tableRecords.pagination,
                totalRecords: totalRecords,
              },
            },
          });
        }
      },
      (error) => {
        console.log("error", error);
        Loader();
      }
    );

    console.log("getDomainCertificate END", this.state);
  };
  render() {
    const breadCrumbs = {
      backHistory: [
        {
          href: "/settings",
          name: "Settings",
        },
      ],
      pageTitle: "Certificate Config",
      buttonList: [],
    };
    const buttonList = [
      {
        name: "Add New",
        type: "addNew",
        clickHandler: this.CreateNewCertificateModel,
        attributes: {
          className: "btn primary_bg",
        },
      },
    ];
    const colData = {
      access_mode: true,
      href: "#",
      clickHandler: this.CreateNewCertificateModel,
      attributes: {
        className: "btn primary_bg",
      },
      value: "+Add New Certificate",
    };
    const header = {
      attributes: {
        className: "btn primary_bg",
      },
    };

    breadCrumbs.buttonList.push({
      href: "",
      attributes: {
        className: "btn primary_bg mr-1",
      },
      name: "Import Certificate",
      type: "importCertificate",
      clickHandler: this.importCertificateHandler.bind(),
    });
    breadCrumbs.buttonList.push({
      href: "",
      attributes: {
        className: "btn primary_bg",
      },
      name: "Add Certificate",
      type: "addNewCertificate",
      clickHandler: this.CreateNewCertificateModel.bind(),
    });
    
   
    
    const headerTabs = [
      {
        name: "Domain Config",
        attributes: {
          "aria-selected": false,
          className: "nav-link",
        },
        href: "/domain-management/domain-config",
      },
      {
        name: "Certificate Config",
        attributes: {
          "aria-selected": true,
          className: "nav-link active show",
        },
        href: "/domain-management/certificate-config",
      },
    ];

    //     let NoRecordSkeletons = <div className="table_Box dataTables_wrapper">
    //     <div className="table_Body d-flex align-items-center justify-content-center">
    //        <div className="text-center" style={{"zIndex":"1"}}>
    //           <h4 className="mb-3" style={{"color":"#1d7af3"}}> Add Certificate and get Certification</h4>
    //           <div className="btn-group">
    //              <Buttons header={header}  colData ={colData} buttonList={buttonList} />
    //           </div>
    //        </div>
    //     </div>
    //  </div>
    //  <div className="kanbanSkelton">
    //         <img src="/assets/img/Skeleton_View.jpg"/>
    //     </div>
    //  </div>

    return (
      <Wrp>
        <BreadCrumbs breadCrumbsList={breadCrumbs} />
        <HeaderTabs
          attributes={{
            className:
              "nav nav-pills navcrm-primary nav-pills-no-bd fixed-2",
          }}
          headerTabsList={headerTabs}
        />
        <div className="viewport">
          <div className="view view-xl">
            
            {this.state.tableRecords.pagination.totalRecords === 0 ? (
              // <NoRecordSkeleton viewType={'LIST'} {...this.props} />
              //     <div>
              <div  className="outerPort">
                <div className="table_Box dataTables_wrapper">
                  <div className="table_Body d-flex align-items-center justify-content-center">
                    <div className="text-center" style={{ zIndex: "1" }}>
                      <h4 className="mb-3" style={{ color: "#1d7af3" }}>
                        {" "}
                        Add Certificate and get Certification
                      </h4>
                      <div className="btn-group">
                        <Buttons
                          header={header}
                          colData={colData}
                          buttonList={buttonList}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="kanbanSkelton">
                  <img src="/assets/img/Skeleton_View.jpg" />
                </div>
              </div>
            ) : (
              <div  className="outerPort">
              <TableRecord
                tableRecords={this.state.tableRecords}
                recordsChangeHandler={this.recordChangeHandler}
              />
              </div>
            )}

            <CreateDomainCertificate
              {...this.props}
              {...this.state}
              valueChangeHandler={this.valueChangeHandler}
              toggleModel={this.toggleModel}
              countryChangeHandler={this.PickListChangeHandler}
              saveHandler={this.saveHandler}
            />
            <ImportCertificate
            {...this.props}
            getCertificateList={this.getCertificateList}
            toggleModel={this.toggleModel}
            isModalOpen={this.state.isImportCertificateModelOpen}
            />
            <CertificateDetail
              isModelOpen={this.state.isCertificateDetailModelOpen}
              domainKey={this.state.domainKey}
              item={this.state.certificate}
              textUpload={this.textBoxUpload}
              valueChangeHandler={this.valueChangeHandler}
              getSelfAuthorizedCertificate={this.getSelfAuthorizedCertificate}
              certificateTextValue={this.state.certificateTextArea}
              toggleModel={this.CertificateDetailToggel}
              fileClickHandler={this.fileOnSelect}
              uploadFileHandler={this.uploadFiles}
              fileSelect={this.fileSelect}
              fileName={this.state.fileName}
              keyChainFile={this.state.selectedKeyChainFile}
              certificateFile={this.state.selectedCertificateFile}
              fileDownload={this.fileDownload}
            />
          </div>
        </div>
      </Wrp>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    Loader: (msg) => dispatch(actions.loader(msg)),
    succMessage: (msg) => dispatch(actions.succMessage(msg)),
    failMessage: (msg) => dispatch(actions.failMessage(msg)),
  };
};
export default connect(
  null,
  mapDispatchToProps
)(withRouter(withTranslation()(CertificateList)));
